import { GET_PERMISSION } from "../types";

const initialState = {
  permission: [],
};

export const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PERMISSION:
      return {
        ...state,
        permission: action.payload,
      };

    default:
      return state;
  }
};
